import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { createElement } from 'react';
import { identity } from '../../utils/util.js';
import { TabsContext } from '../TabsContext/TabsContext.js';
import { TabsList } from '../TabsList/TabsList.js';
import { TabsPanel } from '../TabsPanel/TabsPanel.js';
import { TabsTab } from '../TabsTab/TabsTab.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var Tabs = /*#__PURE__*/React.forwardRef(function Tabs2(props, ref) {
  var initialValue = props.initialValue,
      _props$renderTabPanel = props.renderTabPanel,
      renderTabPanel = _props$renderTabPanel === void 0 ? identity : _props$renderTabPanel,
      tabListProps = props.tabListProps,
      tabs = props.tabs;

  var _React$useState = React.useState(initialValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var elements = tabs.reduce(function (acc, _ref, i) {
    var tabProps = _ref.tabProps,
        tabPanelProps = _ref.tabPanelProps;
    acc.tabElements.push( /*#__PURE__*/createElement(TabsTab, _objectSpread(_objectSpread({}, tabProps), {}, {
      key: i,
      value: i
    })));
    acc.tabPanelElements.push( /*#__PURE__*/createElement(TabsPanel, _objectSpread(_objectSpread({}, tabPanelProps), {}, {
      key: i,
      value: i
    })));
    return acc;
  }, {
    tabElements: [],
    tabPanelElements: []
  });
  return /*#__PURE__*/jsxs(TabsContext, {
    value: value,
    children: [/*#__PURE__*/jsx(TabsList, _objectSpread(_objectSpread({}, tabListProps), {}, {
      onChange: setValue,
      ref: ref,
      children: elements.tabElements
    })), renderTabPanel(elements.tabPanelElements)]
  });
});
Tabs.propTypes = {
  "initialValue": _PropTypes.number.isRequired,
  "renderTabPanel": _PropTypes.func,
  "tabListProps": _PropTypes.object,
  "tabs": _PropTypes.arrayOf(_PropTypes.shape({
    "tabPanelProps": _PropTypes.object.isRequired,
    "tabProps": _PropTypes.object.isRequired
  })).isRequired
};
Tabs.displayName = "Tabs";

export { Tabs };
